import React from 'react'
import BasicSetupDetails from '../SetupDetails/BasicSetupDetails'
import CommunitySetupDetails from '../SetupDetails/CommunitySetupDetails'
import CoursesSetupDetails from '../SetupDetails/CoursesSetupDetails'
import InviteMembersSetupDetails from '../SetupDetails/InviteMembersSetupDetails'
import SubscriptionSetupDetails from '../SetupDetails/SubscriptionSetupDetails'
import { ReactComponent as ChevronDownIcon } from 'assets/img/arrow-down.svg'
import { ReactComponent as ChevronUpIcon } from 'assets/img/arrow-up.svg'
import WelcomeVideo from '../SetupDetails/WelcomeVideo/WelcomeVideo'
import { basicsetupDetailsData } from '../SetupDetails/BasicSetupDetails/data'
import { communitysetupDetailsData } from '../SetupDetails/CommunitySetupDetails/data'
import { coursesSetupDetailsData } from '../SetupDetails/CoursesSetupDetails/data'
import { subscriptionSetupDetailsData } from '../SetupDetails/SubscriptionSetupDetails/data'
import "./styles.scss"
import { welcomeVideoData } from '../SetupDetails/WelcomeVideo/data'
import ContentLibrary from '../SetupDetails/ContentLibrary'
import CommunitySettingsSetupDetails from '../SetupDetails/CommuitySettingsSetupDetails/CommuitySettingsSetupDetails'
import LandingPageSetupDetails from '../SetupDetails/LandingPageSetupDetails'
import WorkflowSetupDetails from '../SetupDetails/WorkflowSetupDetails'
import { WorkflowSetupDetailsDetails } from '../SetupDetails/WorkflowSetupDetails/data'
import { CommuitySettingsSetupDetailsDetails } from '../SetupDetails/CommuitySettingsSetupDetails/data'
import { LandingPageSetupDetailsData } from '../SetupDetails/LandingPageSetupDetails/data'


export interface IOnboardingItemIntro {
    title: string,
    description: string,
    groupData: any
    itemsLength: number
    compSelected: any,
}

const OnboardingItemIntro: React.FC<IOnboardingItemIntro> = ({
    title, description, groupData, itemsLength, compSelected,
}) => {
    const [visibleId, setVisibleId] = React.useState<number | null>(5);
    const currentSubdomain = window.location.hostname.split(".");
    const subdomain = currentSubdomain[0]

    const toggleVisibility = (selectedId: any) => {
        setVisibleId((prevId) => (prevId === selectedId ? null : selectedId));
    };

    const Welcome = {
        text: "Welcome", selected: 5, title: 'Welcome', description: 'Get familiar with GroupApp by watching our quick overview video.',
        dataLength: welcomeVideoData.length
    }

    const BasicSetup = {
        text: "Community Home Page", selected: 0, title: 'Community Home Page', description: 'Customize your community home page settings.',
        dataLength: basicsetupDetailsData.length
    }

    const Channels = {
        text: "Channels", selected: 1, title: 'Channels', description: 'Organize and structure your community spaces for different topics and members.',
        dataLength: communitysetupDetailsData.length
    }
    const Courses = {
        text: "Courses", selected: 4, title: 'Courses', description: 'Create and deliver engaging online courses and training programs.',
        dataLength: coursesSetupDetailsData.length
    }
    const Events = {
        text: "Events", selected: 6, title: 'Events', description: 'Schedule, manage, and run successful community events.',
        dataLength: 1
    }
    const Subscriptions = {
        text: "Subscriptions", selected: 2, title: 'Subscriptions', description: 'Set up and manage paid membership plans for your community.',
        dataLength: subscriptionSetupDetailsData.length
    }
    const OnboardingSetup = {
        text: "Member Onboarding", selected: 3, title: 'Member Onboarding', description: 'Create a smooth welcome experience for new members joining your community.',
        dataLength: 2
    }
    const Workflow = {
        text: "Workflows", selected: 7, title: 'Workflows', description: 'Create email sequences and automate community tasks to drive engagement.',
        dataLength: WorkflowSetupDetailsDetails.length
    }
    const LandingPage = {
        text: "Landing Pages", selected: 8, title: 'Landing Pages', description: 'Create high-converting landing pages for your membership programs, courses, and events.',
        dataLength: LandingPageSetupDetailsData.length
    }
    const AddingMembers = {
        text: "Adding Members", selected: 9, title: 'Adding Members', description: 'Invite members to your community and manage invitation settings.',
        dataLength: CommuitySettingsSetupDetailsDetails.length
    }

    return (
        <>
            <div className='setup-details-con'>
                <div className='setup-details-div' onClick={() => toggleVisibility(5)}>
                    <div className='setup-details-h1'>
                        <span>{Welcome.title}</span>
                    </div>
                    {
                        visibleId === 5 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 5 &&
                    <WelcomeVideo
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={visibleId}
                        key={5}
                        description={Welcome.description}
                    />
                }

            </div>

            {/* community homepage */}
            <div className='setup-details-con'>
                <div className='setup-details-div' onClick={() => toggleVisibility(0)}>
                    <div className='setup-details-h1'>
                        <span>{BasicSetup.title}</span>
                    </div>
                    {
                        visibleId === 0 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 0 &&
                    <BasicSetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={visibleId}
                        key={0}
                        description={BasicSetup.description}
                    />
                }
            </div>

            {/* channels */}
            <div className='setup-details-con'>
                <div className='setup-details-div' onClick={() => toggleVisibility(1)}>
                    <div className='setup-details-h1'>

                        <span>{Channels.title}</span>
                    </div>
                    {
                        visibleId === 1 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 1 &&
                    <CommunitySetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={visibleId}
                        key={1}
                        description={Channels.description}
                    />
                }
            </div>

            {/* community onboarding */}
            <div className='setup-details-con'>

                <div className='setup-details-div' onClick={() => toggleVisibility(3)}>
                    <div className='setup-details-h1'>
                        <span>{OnboardingSetup.title}</span>
                    </div>
                    {
                        visibleId === 3 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 3 &&
                    <InviteMembersSetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={visibleId}
                        key={3}
                        description={OnboardingSetup.description}
                    />
                }
            </div>

            {/* Adding members */}
            <div className='setup-details-con'>
                <div className='setup-details-div' onClick={() => toggleVisibility(9)}>
                    <div className='setup-details-h1'>
                        <span>{AddingMembers.title}</span>
                    </div>
                    {
                        visibleId === 9 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 9 &&
                    <CommunitySettingsSetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={9}
                        key={9}
                        description={AddingMembers.description}
                    />
                }
            </div>

            {/* Subscription */}
            <div className='setup-details-con'>
                <div className='setup-details-div' onClick={() => toggleVisibility(2)}>
                    <div className='setup-details-h1'>
                        <span>{Subscriptions.title}</span>
                    </div>
                    {
                        visibleId === 2 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 2 &&
                    <SubscriptionSetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={visibleId}
                        key={2}
                        description={Subscriptions.description}
                    />
                }
            </div>

            {/* Courses */}
            <div className='setup-details-con'>

                <div className='setup-details-div' onClick={() => toggleVisibility(4)}>
                    <div className='setup-details-h1'>
                        <span> {Courses.title}</span>
                    </div>
                    {
                        visibleId === 4 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 4 &&
                    <CoursesSetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={visibleId}
                        key={4}
                        description={Courses.description}
                    />
                }
            </div>

            {/* Events */}
            <div className='setup-details-con'>

                <div className='setup-details-div' onClick={() => toggleVisibility(6)}>
                    <div className='setup-details-h1'>
                        <span>{Events.title}</span>
                    </div>
                    {
                        visibleId === 6 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 6 &&
                    <ContentLibrary
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={6}
                        key={6}
                        description={Events.description}
                    />
                }
            </div>

            {/* Landing settings */}
            <div className='setup-details-con'>
                <div className='setup-details-div' onClick={() => toggleVisibility(8)}>
                    <div className='setup-details-h1'>
                        <span>{LandingPage.title}</span>
                    </div>
                    {
                        visibleId === 8 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 8 &&
                    <LandingPageSetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={8}
                        key={8}
                        description={LandingPage.description}
                    />
                }
            </div>

            {/* Workflow */}
            <div className='setup-details-con-no-border'>
                <div className='setup-details-div' onClick={() => toggleVisibility(7)}>
                    <div className='setup-details-h1'>
                        <span>{Workflow.title}</span>
                    </div>
                    {
                        visibleId === 7 ?
                            <ChevronDownIcon />
                            :
                            <div className='setup-details-h1-chevron'>
                                <ChevronUpIcon />
                            </div>
                    }
                </div>

                {
                    visibleId === 7 &&
                    <WorkflowSetupDetails
                        groupData={groupData}
                        subdomain={subdomain}
                        compSelected={7}
                        key={7}
                        description={Workflow.description}
                    />
                }
            </div>

        </>
    )
}

export default OnboardingItemIntro
